<template>
  <v-dialog v-model="dialog" persistent max-width="460">
    <template v-slot:activator="{ on }">
      <div class="title">
        {{ title }} <v-btn color="primary" dark v-on="on">Filters</v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title class="headline">Filters</v-card-title>
      <v-card-text>
        <v-container :fluid="false">
          <DatePicker
            v-model="dateFilter"
            :date="dateFilter.startDate"
            min="2018-01-01"
            :max="dateFilter.max"
            label="Start Date"
            @set-date="setStartDate"
          />
          <DatePicker
            v-model="dateFilter"
            :date="dateFilter.endDate"
            :min="dateFilter.min"
            label="End Date"
            @set-date="setEndDate"
          />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="acceptDate">
          Apply
        </v-btn>
        <v-btn text @click="dialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from "./DatePicker.vue";

const MILLIS_PER_DAY = 24 * 60 * 60 * 1000;

export default {
  components: {
    DatePicker
  },

  props: ["title", "startDate", "endDate"],

  data: () => ({
    dialog: false,
    dateFilter: {}
  }),

  created() {
    let minDate = new Date(new Date(this.startDate).getTime() + MILLIS_PER_DAY)
      .toISOString()
      .substr(0, 10);
    let maxDate = new Date(new Date(this.endDate).getTime() - MILLIS_PER_DAY)
      .toISOString()
      .substr(0, 10);

    this.dateFilter.startDate = this.startDate;
    this.dateFilter.endDate = this.endDate;
    this.dateFilter.min = minDate;
    this.dateFilter.max = maxDate;
  },

  methods: {
    acceptDate() {
      this.dialog = false;
      this.$emit("accept-date", {
        startDate: this.dateFilter.startDate,
        endDate: this.dateFilter.endDate
      });
    },

    setStartDate(val) {
      let minDate = new Date(new Date(val).getTime() + MILLIS_PER_DAY)
        .toISOString()
        .substr(0, 10);

      let newDateFilter = {
        startDate: val,
        endDate: this.dateFilter.endDate,
        min: minDate,
        max: this.dateFilter.max
      };

      this.$set(this, "dateFilter", newDateFilter);
    },

    setEndDate(val) {
      let maxDate = new Date(new Date(val).getTime() - MILLIS_PER_DAY)
        .toISOString()
        .substr(0, 10);

      let newDateFilter = {
        startDate: this.dateFilter.startDate,
        endDate: val,
        min: this.dateFilter.min,
        max: maxDate
      };

      this.$set(this, "dateFilter", newDateFilter);
    }
  }
};
</script>
